module.exports = __webpack_public_path__ + "img/pereladov.55c8c2dd.jpg";